import produce from 'immer';
import { FormType } from '../../enum';
import { Actions } from './action';
import { LmFormState } from './interface';
import { LmFormAction } from './enum';

export const initialState: LmFormState = {
    formData: {
        type: FormType.LM,
        firstName: '',
        lastName: '',
        email: '',
    },
};

const lmReducer = (state = initialState, action: Actions) =>
    produce(state, draft => {
        switch (action.type) {
            case LmFormAction.CHANGE_LM_INPUT:
                draft.formData = {
                    ...state.formData,
                    ...action.payload,
                };
                break;
            case LmFormAction.HANDLE_LM_RESPONSE:
                draft.responseData = action.payload;
                break;
            case LmFormAction.HANDLE_LM_RESPONSE_ERROR:
                draft.lmError = action.payload;
                break;
            case LmFormAction.CLEAR_LM_RESULT:
                draft.responseData = undefined;
                break;
        }
    });

export default lmReducer;
